module.exports = __webpack_public_path__ + "img/248-2485432_file-logosat-sat-logo-png-transparente-png-download-removebg-preview 1.8ad959c4.png";